import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index.js';

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
const routes = [{
        path: '/', //登录页
        name: 'Login',
        component: () => import('../pape/home/Login.vue')
    },{
        path: '/home', //首页 
        name: 'home',
        component: () => import('../pape/home/home.vue')
    }, {
        path: '/search', //搜索
        name: 'search',
        component: () => import('../pape/home/search.vue')
    }, {
        path: '/detail', //商品详情
        name: 'detail',
        component: () => import('../pape/home/detail.vue')
    }, {
        path: "/about", // 我的
        name: 'about',
        component: () => import('../pape/about/about.vue')
    }, {
        path: '/aboutCoupon', //我的优惠券
        name: 'aboutCoupon',
        component: () => import('../pape/about/aboutCoupon.vue')
    }, {
        path: '/AboutCollect', //我的收藏
        name: 'AboutCollect',
        component: () => import('../pape/about/AboutCollect.vue')
    }, {
        path: '/AboutAddress', //我的地址
        name: 'AboutCollect',
        component: () => import('../pape/about/AboutAddress.vue')
    }, {
        path: '/AboutNewAddress', //新建地址
        name: 'AboutNewAddress',
        component: () => import('../pape/about/AboutNewAddress.vue')
    }, {
        path: '/ContributionValue', //贡献值
        name: 'ContributionValue',
        component: () => import('../pape/about/ContributionValue.vue')
    },{
        path: '/orderlist', //订单列表
        name: 'orderlist',
        component: () => import('../pape/order/orderlist.vue')
    }, {
        path: '/orderConfirm', //确认订单
        name: 'orderConfirm',
        component: () => import('../pape/order/orderConfirm.vue')
    }, {
        path: '/orderDetail', //订单详情
        name: 'orderDetail',
        component: () => import('../pape/order/orderDetail.vue')
    }, {
        path: '/remitMoney', //去汇款
        name: 'remitMoney',
        component: () => import('../pape/order/remitMoney.vue')
    }]
const VueRouter = new Router({
    routes,
});
export default VueRouter;



// WEBPACK FOOTER //
// ./src/router/index.js